import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import {
  getTripDetailsV3,
  deleteTripJourney
} from "../../../store/actions/tripActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
const useStyles = makeStyles((theme) => ({
  info: {
    padding: 24,
    backgroundColor: '#d6def7',
    height: '100%',
    minHeight: 100,
    maxHeight: 100,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    color: '#0033cc',
    alignItems: 'center',
    fontWeight: 300
  }
}));
const DeleteTripJourney = (props) => {
  const { location,user,loadId, deleteOpen, dispatchTripDetailsAction, dispatchDeleteTrip, onDeleteSucees, onDeleteNo } = props;
  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(deleteOpen);
  let journey = user.singleTripData ? user.singleTripData : {};
  let trips = journey && journey.trips?journey.trips:[]
  let tripsLength = trips?trips.length:null
  let LoadOrTrip = tripsLength && tripsLength==1 && !loadId?'Trip':'Load' 
  let confirmMessage = `Are you sure, you want to Delete the ${LoadOrTrip}?`;
  let confirmTitle = `Delete ${LoadOrTrip}`;
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const onConfirm = (confirm) => {
    let tripId = loadId?loadId:trips&&trips.length==1 && trips[0] && trips[0].id?trips[0].id:null
    if (confirm && journey &&  journey.id && tripId) {
      dispatchDeleteTrip(journey.id,tripId, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(`${LoadOrTrip} Deleted Suceessfully!`);
          onDeleteSucees()
        } else {
        }
      },
        () => {
        })
    } else {
      onDeleteNo()
      //fetchTrip(tripId) 
    }
  }
  return (
    <>
      {open && <ConfirmDialog confirmOpen={open} confirmTitle={confirmTitle} confirmMessage={confirmMessage} onClose={onConfirm} />
      }    </>
  );
}
DeleteTripJourney.propTypes = {
  tripId: PropTypes.any.isRequired,
};
const DeleteTripJourneyWithRouter = withRouter(DeleteTripJourney);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchDeleteTrip: (journeyId,tripId, onSuccess, onFailure) => { dispatch(deleteTripJourney(journeyId,tripId, onSuccess, onFailure)) },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteTripJourneyWithRouter);